import { render, staticRenderFns } from "./Commands.vue?vue&type=template&id=b475f7c8&scoped=true"
import script from "./Commands.vue?vue&type=script&lang=js"
export * from "./Commands.vue?vue&type=script&lang=js"
import style0 from "./Commands.vue?vue&type=style&index=0&id=b475f7c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475f7c8",
  null
  
)

export default component.exports